import { isDefined } from "@omni/utils/helper.utils";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatPrice } from "@/utils/price.utils";

import TotalsRowComponent from "./totalsRow.component";

type TotalsBlockComponentProps = {
    subTotal?: number | null;
    deliveryCost?: number | null;
    discountTotal?: number | null;
    giftCardTotal?: number | null;
    serviceTotal?: number | null;
    totalPrice?: number | null;
};

const TotalsBlockComponent = ({
    subTotal,
    deliveryCost,
    discountTotal,
    giftCardTotal,
    serviceTotal,
    totalPrice
}: TotalsBlockComponentProps) => {
    const { t } = useGranite();

    return (
        <div>
            {serviceTotal && (
                <TotalsRowComponent
                    label={"general.miniCart.totals.serviceTotal"}
                    value={formatPrice(serviceTotal)}
                />
            )}
            <TotalsRowComponent
                label={"general.miniCart.totals.subTotal"}
                value={formatPrice(subTotal ?? undefined)}
            />
            {isDefined(deliveryCost) && (
                <TotalsRowComponent
                    label={"general.miniCart.totals.deliveryCost"}
                    value={formatPrice(deliveryCost, { freeLabel: true, t: t })}
                />
            )}
            {discountTotal && (
                <TotalsRowComponent
                    label={"general.miniCart.totals.globalDiscounts"}
                    value={`-${formatPrice(discountTotal)}`}
                />
            )}
            {giftCardTotal && (
                <TotalsRowComponent
                    label={"general.miniCart.totals.paidByGiftCard"}
                    value={`-${formatPrice(giftCardTotal)}`}
                />
            )}
            <TotalsRowComponent
                label={"general.miniCart.totals.totalPrice"}
                value={formatPrice(totalPrice ?? undefined)}
                isTotalPrice={true}
            />
        </div>
    );
};

export default TotalsBlockComponent;
